<section class="py-5">
    <div class="py-3 container">
        <div class="row">
            <div class="col-md-12">
                <div class="title">
                    <h1 class="fw-bold text-black">Cancellation and Refund Policy</h1>
                </div>

                <div class="py-4">
                     <h2 class="txt-title fs-4 mb-4 text-black">
                        Cancellation Policy</h2>

                        <p class="txt-description mb-4 text-secondary">
                      You may cancel your subscription at any time through your Illusbook account settings. Please note:
                    </p>

                    <ul class="txt-description mb-5 text-secondary">
                        <li class="mb-3">
                          Cancellations take effect at the end of the current billing cycle.
                        </li>
                        <li class="mb-3">
                         You will retain access to premium content and features until your subscription period expires.
                        </li>
                        <li class="mb-3">
                        We do not offer partial or prorated refunds for any unused time remaining in your active subscription.
                        </li>
                           <li class="mb-3">
                       To cancel your subscription, contact our support team at <a class="un-link bold"
                                href="mailto:support@illusbook.com">support&#64;illusbook.com</a> provided.
                        </li>
                    </ul>
                    <h2 class="txt-title fs-4 mb-4 text-black">
                        Refund Policy for Digital Subscriptions</h2>

                    <p class="txt-description mb-4 text-secondary">
                        All subscription plans on Illusbook provide access to premium digital illustrations and assets. Please note that:
                    </p>

                      <ul class="txt-description mb-5 text-secondary">
                        <li class="mb-3">
                          All subscription purchases are final and non-refundable.
                        </li>
                        <li class="mb-3">
                          By subscribing, you acknowledge that you are purchasing instant access to premium digital assets and agree to the terms of this refund policy.
                        </li>
                        <li class="mb-3">
                         Once your plan is activated, no refunds will be issued, regardless of usage or satisfaction level.
                        </li>
                    </ul>

                     <h2 class="txt-title fs-4 mb-4 text-black">
                        No Refunds for Downloaded Assets</h2>

                    <p class="txt-description mb-4 text-secondary">
                 Due to the digital and downloadable nature of the content, refunds are not applicable under the following circumstances:
                    </p>

                    <ul class="txt-description mb-4 text-secondary">
                        <li class="mb-3">
                           You did not use or download the assets
                        </li>
                        <li class="mb-3">
                          You changed your mind after subscribing
                        </li>
                        <li class="mb-3">
                           You expected different content
                        </li>
                    </ul>

                    <p class="txt-description mb-5 text-secondary">
                We strongly recommend reviewing sample assets or the Free plan before subscribing to Premium.
                    </p>

                       <h2 class="txt-title fs-4 mb-4 text-black">
                        Billing Disputes and Duplicate Charges</h2>

                         <p class="txt-description mb-4 text-secondary">
                     In case of:
                    </p>

                        <ul class="txt-description mb-4 text-secondary">
                        <li class="mb-3">
                         Duplicate charges
                        </li>
                        <li class="mb-3">
                         Technical errors during billing
                        </li>
                        <li class="mb-3">
                          Subscription activation issues
                        </li>
                    </ul>

                    <p class="txt-description mb-5 text-secondary">
                    Please contact us within 3 working days from the transaction date at: <a class="un-link bold"
                                href="mailto:support@illusbook.com">support&#64;illusbook.com</a> Our support team will investigate the issue and provide a resolution within 7 business days.
                    </p>

                    <h2 class="txt-title fs-4 mb-4 text-black">
                        Grievance Redressal</h2>

                         <p class="txt-description mb-4 text-secondary">
                    For escalation of unresolved billing or refund issues:
                    </p>

                    <ul class="txt-description mb-5 text-secondary">
                        <li class="mb-3">
                         Grievance Officer: Illusbook Support Team  
                        </li>
                        <li class="mb-3">
                         Email: support@illusbook.com  
                        </li>
                        <li class="mb-3">
                          Resolution Time: Within 7 working days
                        </li>
                    </ul>
                    
                    <h2 class="txt-title fs-4 mb-4 text-black">
                        Governing Law and Jurisdiction</h2>

                        <p class="txt-description mb-4 text-secondary">
                    All policies and disputes are governed by the laws of India. Any disputes relating to cancellations, payments, or refunds shall be subject to the jurisdiction of courts in Coimbatore, Tamil Nadu, India.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>